import React, { FC, useContext, useState } from 'react';
import { Avatar, Dropdown } from 'antd';
import { companyLogoPublic } from "../../../../../assets/images/logo";
import { useLang } from "../../../../../hooks/useLang";
import MenuWidget from "../../../../../components/Widget/MenuWidget";
import AccountMenu from "../../../../../components/Menu/AccountMenu/AccountMenu";
import { UserOutlined, MenuOutlined } from "@ant-design/icons";
import { usePermissionContext } from "../../../../../hooks/context/usePermissionContext";
import { AuthContext } from "../../../../../context/auth/auth.context";
import AdminProfileMenu from "../../../../../components/Menu/ProfileMenu/ProfileMenu";
import { useScrollToTop } from "../../../../../hooks/useScrollToTop";
import './Header.style.scss';
import LanguageSelector from '../../../../../components/Language/LanguageSelector';
import { ReactComponent as TranslationIcon } from '../../../../../assets/images/svg/translation.svg';
import { ReactComponent as PhoneIcon } from "../../../../../assets/images/svg/phone.svg";
import { ReactComponent as LoginIcon } from "../../../../../assets/images/svg/sign-in-squre.svg";
import { BASE_URL, SECURITY_UI_URL } from "../../../../../constants/config.constant";
import HelpModal from "../Help/Help.modal";

const HeaderTop: FC<any> = props => {
    useScrollToTop();
    const { t, lang, getLangUrl, getAdminLangUrl, getUserLangUrl } = useLang();
    const { isPermissionLoaded, hasPermission } = usePermissionContext();
    const { user, isAuthenticated, isUser, isAdmin } = useContext(AuthContext);
    const [isShowMobileMenu, setIsShowMobileMenu] = useState(false);

    return (
        <div className="header-container">
            <div className="header-top px-3 py-1">
                <div className="header-top-content">
                    <div className="header-top-left d-none d-md-block mt-1 mt-md-0 pe-2">
                        <a href="https://bangladesh.gov.bd/" className="text-white" target="_blank" rel="noopener noreferrer">{t('National Portal')}</a>
                        <span className="mx-2">|</span>
                        <a href="https://www.mygov.bd/" className="text-white" target="_blank" rel="noopener noreferrer">{t('National Service Portal')}</a>
                    </div>
                    <div className="header-top-right">
                        <HelpModal />
                        |
                        <span className="language-switcher d-inline-block px-2">
                            <TranslationIcon aria-hidden="true" className="me-2 d-none d-sm-inline-block" style={{ fill: '#fff', width: 'auto', height: 20, verticalAlign: 'middle' }} />
                            <LanguageSelector />
                        </span>
                        |
                        <span className="header-auth-block d-inline-block ps-2">
                            {isAdmin === true && (
                                <Dropdown
                                    overlayClassName="avatar-menu-drop-down"
                                    overlay={AdminProfileMenu(user, isPermissionLoaded, hasPermission, t, lang, getLangUrl, getAdminLangUrl, getUserLangUrl)}
                                    trigger={['click']}
                                    placement="bottomRight"
                                >
                                    <span className="action account">
                                        <Avatar size={24} icon={<UserOutlined style={{ color: '#000' }} />} />
                                        <span className="name">{props.account ? props.account.name : null}</span>
                                    </span>
                                </Dropdown>
                            )}
                            {isUser === true && (
                                <Dropdown
                                    overlayClassName="avatar-menu-drop-down"
                                    overlay={AccountMenu(user, isPermissionLoaded, hasPermission, t, lang, getLangUrl, getAdminLangUrl)}
                                    trigger={['click']}
                                    placement="bottomRight"
                                >
                                    <span className="action account">
                                        <Avatar size={24} icon={<UserOutlined style={{ color: '#000' }} />} />
                                        <span className="name">{props.account ? props.account.name : null}</span>
                                    </span>
                                </Dropdown>
                            )}
                            {!isAuthenticated && (
                                <>
                                    <a className="text-white me-2 d-none d-sm-inline-block" href={getLangUrl(lang, '/auth/register', SECURITY_UI_URL, true)}>
                                        <UserOutlined aria-hidden="true" className="me-2" style={{ verticalAlign: 'text-bottom', color: '#fff' }} />
                                        {t('Sign up')}
                                    </a>
                                    <a className="text-white" href={getLangUrl(lang, `/auth/login?servicename=Library&redirect_uri=${BASE_URL}`, SECURITY_UI_URL, true)}>
                                        <LoginIcon className="login-icon" style={{ verticalAlign: 'middle', height: '20px' }} />
                                        {t('Login')}
                                    </a>
                                </>
                            )}
                        </span>
                    </div>
                </div>
            </div>
            <div className="header-bottom">
                <div className="header-bottom-content py-2 px-3">
                    <a href={getLangUrl(lang, '/', SECURITY_UI_URL, true)} className="site-link">
                        <img className="float-start me-2 site-logo" src={companyLogoPublic} alt={t("Logo of the Government of the People's Republic of Bangladesh")} width="60" height="60" />
                        <hgroup>
                            <h1 className="site-title h4 mb-0 text-white" style={{ lineHeight: '32px' }}>
                                <span className="d-none d-md-block">{t('Digital Service Portal')}</span>
                                <span className="d-md-none" aria-hidden="true" title={t('Digital Service Portal')}>{t('DSP')}</span>
                            </h1>
                            <h2 className="site-subtitle fw-normal h6 mb-0 text-white" style={{ lineHeight: '20px' }}>
                                <span className="d-none d-md-block">{t('Ministry of Science & Technology')}</span>
                                <span className="d-md-none" aria-hidden="true" title={t('Ministry of Science & Technology')}>{t('MoST')}</span>
                            </h2>
                        </hgroup>
                    </a>
                    <button type="button" className="btn-toggle-nav d-md-none mt-2" onClick={() => setIsShowMobileMenu(!isShowMobileMenu)} aria-controls="main-menu" aria-expanded={isShowMobileMenu ? 'true' : 'false'}>
                        <MenuOutlined className="me-1" aria-hidden="true" />
                        {t('Menu')}
                    </button>
                    <nav id="main-menu" className={`main-menu mt-md-2 ${isShowMobileMenu ? 'nav-visible-mobile' : ''}`}>
                        <MenuWidget parentId={1} />
                    </nav>
                </div>
            </div>
        </div>
    );
}

export default React.memo(HeaderTop);
